export function docCompareResultUrl(sessionId: number) {
  return `/compare/result/${sessionId}`
}
